import React from "react";
import { Tooltip } from "antd";
import { InputWrapper, CheckboxLabel, WrapperCol } from "../../style";
import { NoWrapLabel, AllSharesAllPoolsHeader } from "./style";
import { CustomCheckbox, DisplayFlex } from "../../../../../../CommonComponents/commonStyles";
import CurrencyInput from "../../../../../../CommonComponents/CurrencyInput/CurrencyInput";
import { formatAmount } from "../../../../../../utils/commonUtil";
import PercentageInput from "../../../../../../CommonComponents/PercentageInput/PercentageInput";
import TooltipComponent from "../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import { replaceSelect } from "../../../../../../utils/replacer"

const tabConfigColumn = (
  allocationPreference,
  onAllocationRadioChange,
  allocType,
  onGrantPercentageChange,
  onGrantAmountChange,
  checkAmountLimits,
  scheduleType,
  allSharesCheck,
  onAllShareChange,
  showAllSharesAllPools,
  onAllSharesAllPoolsChange,
  allSharesAllPoolsCheck,
  showAllSharesColumn,
  disableAllInputs,
  isGrantAgreement,
  fromEdit,
  rowCheked,
  entireBalPopup
) => {
  const cols = [
    {
      title: "Investment Options",
      dataIndex: "name",
      key: "investmentOption",
      width: allocationPreference === "entireBalance" ? "25%" : "20.833%",
      render: (value, record) => {
        return <div>{replaceSelect(value)}</div>;
      }
    },
    {
      title: "Available Balance",
      dataIndex: "availableBalance",
      key: "availableBalance",
      width: allocationPreference === "entireBalance" ? "25%" : "20.833%",
      render: (value, record) => {
        return <div>{formatAmount(value)}</div>;
      }
    },
    {
      title: isGrantAgreement ? "Investment Allocation**" : allocationPreference === "entireBalance" ? () => <span>Account <br/>Allocation**</span>: "Account Allocation**",
      dataIndex: "percentShare",
      key: "percentShare",
      render: (value, record) => {
        return <div>{value}%</div>;
      }
    },
    ... allocationPreference === "entireBalance" ? [] : [{
      title: () => {
        return (
          <>
            {allocationPreference !== "weightedAllocations" ? (
              <>
                <NoWrapLabel>Grant Percentage</NoWrapLabel>
              </>
            ) : (
                "Grant Percentage"
              )}
          </>
        );
      },
      dataIndex: "grantPercentage",
      key: "grantPercentage",
      render: (value, record) => {
        return (
          <InputWrapper>
            <PercentageInput
              maxLength={150}
              onChange={e => onGrantPercentageChange(e, record,allocationPreference)}
              value={value}
              onBlur={e => checkAmountLimits(record)}
              id={`txtGrantPercentage${record.id}`}
              label="grant-percentage"
              fullWidth
            />
          </InputWrapper>
        );
      }
    }],
    {
      title: () => {
        return (
          <>
            {allocationPreference !== "weightedAllocations" ? (
              <>
                <NoWrapLabel>Grant Amount</NoWrapLabel>
              </>
            ) : (
                "Grant Amount"
              )}
          </>
        );
      },
      dataIndex: "grantAmount",
      key: "grantAmount",
      width: "20.833%",
      render: (value, record) => {
        return (
          <>
            <InputWrapper>
              <DisplayFlex>
                <CurrencyInput
                  id={`txtGrantAmount${record.id}`}
                  label="grant-amount"
                  maxLength={150}
                  onChange={e => onGrantAmountChange(e, record,allocationPreference)}
                  value={value}
                  onBlur={e => checkAmountLimits(record)}
                  fullWidth
                  disabled={
                    allocType === "entireBalance"
                    || allSharesAllPoolsCheck
                    || allSharesCheck
                    || disableAllInputs
                  }
                />
              </DisplayFlex>
            </InputWrapper>
          </>
        );
      }
    }
  ];

  return allocationPreference !== "entireBalance" ? cols : [
    {
      title: () => {
          return (
            <>
              <WrapperCol>
                <TooltipComponent
                  overlayclassName="grantAllocationTooltip"
                  className="grantAllshareAllPoolHead"
                  placement={ fromEdit ? "topLeft" : "left" }
                  text="Choosing this option will grant the entire available balance of your DAF account. This will close your account once the grant is issued."
                />
                <InputWrapper>
                  <DisplayFlex>
                    <CustomCheckbox
                      onChange={e => onAllSharesAllPoolsChange(e)}
                      checked={allSharesAllPoolsCheck}
                      disabled={entireBalPopup || disableAllInputs}
                      id="chkAllSharesAllPools"
                      aria-label="all-share-all-pool"
                    />
                  </DisplayFlex>
                </InputWrapper>
              </WrapperCol>
            </>
          );
      },
      key: "allShares",
      width: "10%",
      render: (value, record) => {
        return (
          <>
            <WrapperCol>
              <TooltipComponent
                overlayclassName="grantAllocationTooltip"
                placement={ fromEdit ? "topLeft" : "left" }
                text="Choosing this option will change the grant amount to the entire available balance of the investment option selected."
              />
              <InputWrapper>
                <DisplayFlex>
                  <CustomCheckbox
                    id={`chkAllShare${record.id}`}
                    aria-label="all-share"
                    onChange={e => onAllShareChange(e, record)}
                    checked={record.allShare}
                    disabled={rowCheked || allSharesAllPoolsCheck || disableAllInputs} />
                </DisplayFlex>
              </InputWrapper>
            </WrapperCol>
          </>
        );
      }
    }, ...cols
  ]
};

export default tabConfigColumn;
